"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLazyExportDisbursementReportQuery = exports.useLazyExportBillingReportQuery = exports.useLazyGetAuditLogsQuery = exports.useGetAuditLogsQuery = exports.useLazyGetOrderReportQuery = exports.useGetOrderReportQuery = exports.useGetStockHistoryReportQuery = exports.useGetFailedVouchersReportQuery = exports.useGetStockReportQuery = exports.useLazyGetDisbursementReportQuery = exports.useGetDisbursementReportQuery = exports.useLazyGetBillingReportQuery = exports.useGetBillingReportQuery = exports.useGetRecentDisbursementsQuery = exports.useGetRecentOrdersQuery = exports.useLazyGetDashboardStatsQuery = exports.useGetDashboardStatsQuery = exports.reportsApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.reportsApi = (0, react_1.createApi)({
    reducerPath: "reportsApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.API_URL),
    tagTypes: ["Reports"],
    endpoints: function (builder) { return ({
        getDashboardStats: builder.query({
            query: function () { return "/v1/reports/dashboard"; },
        }),
        getRecentOrders: builder.query({
            query: function (params) { return ({
                url: "/v1/reports/recent-orders",
                params: params,
            }); },
        }),
        getRecentDisbursements: builder.query({
            query: function (params) { return ({
                url: "/v1/reports/recent-disbursements",
                params: params,
            }); },
        }),
        getBillingReport: builder.query({
            query: function (params) { return ({
                url: "/v1/reports/billing",
                params: params,
            }); },
        }),
        getDisbursementReport: builder.query({
            query: function (params) { return ({
                url: "/v1/reports/disbursements",
                params: params,
            }); },
        }),
        getStockReport: builder.query({
            query: function (params) { return ({
                url: "/v1/reports/stock",
                params: params,
            }); },
        }),
        getFailedVouchersReport: builder.query({
            query: function (params) { return ({
                url: "/v1/reports/failed-vouchers",
                params: params,
            }); },
        }),
        getStockHistoryReport: builder.query({
            query: function (params) { return ({
                url: "/v1/reports/stock-history",
                params: params,
            }); },
        }),
        getOrderReport: builder.query({
            query: function (params) { return ({
                url: "/v1/reports/orders",
                params: params,
            }); },
        }),
        getAuditLogs: builder.query({
            query: function (params) { return ({
                url: "/v1/reports/audit",
                params: params,
            }); },
        }),
        exportBillingReport: builder.query({
            query: function (params) { return ({
                url: "/v1/reports/billing/export",
                params: params,
                responseHandler: function (response) { return response.blob(); },
            }); },
        }),
        exportDisbursementReport: builder.query({
            query: function (params) { return ({
                url: "/v1/reports/disbursements/export",
                params: params,
                responseHandler: function (response) { return response.blob(); },
            }); },
        }),
    }); },
});
exports.useGetDashboardStatsQuery = exports.reportsApi.useGetDashboardStatsQuery, exports.useLazyGetDashboardStatsQuery = exports.reportsApi.useLazyGetDashboardStatsQuery, exports.useGetRecentOrdersQuery = exports.reportsApi.useGetRecentOrdersQuery, exports.useGetRecentDisbursementsQuery = exports.reportsApi.useGetRecentDisbursementsQuery, exports.useGetBillingReportQuery = exports.reportsApi.useGetBillingReportQuery, exports.useLazyGetBillingReportQuery = exports.reportsApi.useLazyGetBillingReportQuery, exports.useGetDisbursementReportQuery = exports.reportsApi.useGetDisbursementReportQuery, exports.useLazyGetDisbursementReportQuery = exports.reportsApi.useLazyGetDisbursementReportQuery, exports.useGetStockReportQuery = exports.reportsApi.useGetStockReportQuery, exports.useGetFailedVouchersReportQuery = exports.reportsApi.useGetFailedVouchersReportQuery, exports.useGetStockHistoryReportQuery = exports.reportsApi.useGetStockHistoryReportQuery, exports.useGetOrderReportQuery = exports.reportsApi.useGetOrderReportQuery, exports.useLazyGetOrderReportQuery = exports.reportsApi.useLazyGetOrderReportQuery, exports.useGetAuditLogsQuery = exports.reportsApi.useGetAuditLogsQuery, exports.useLazyGetAuditLogsQuery = exports.reportsApi.useLazyGetAuditLogsQuery, exports.useLazyExportBillingReportQuery = exports.reportsApi.useLazyExportBillingReportQuery, exports.useLazyExportDisbursementReportQuery = exports.reportsApi.useLazyExportDisbursementReportQuery;
